import { useMemo, useState } from "react";
import { useNavigate } from "react-router";

import { Button, ButtonStyle, ConfirmModal, DetailCardSection, Modal } from "@prequel/shared-components";

import { useDeleteSource } from "@/api/import/sources";
import DangerZone from "@/components/DangerZone";
import { useSourceContext } from "@/pages/import/SourcesPage/SourcePage";

const SourceAdmin = () => {
  const navigate = useNavigate();
  const { source } = useSourceContext();
  const deleteSource = useDeleteSource();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const onConfirmDelete = () => {
    setShowDeleteModal(false);
    deleteSource.mutate(source.id);
  };

  const dangerZoneActions = useMemo(
    () => [
      {
        label: "Delete source",
        description:
          "This action cannot be undone. All associated datasets must be deleted before this source can be deleted.",
        buttonText: "Delete source",
        onClick: () => setShowDeleteModal(true),
      },
    ],
    [],
  );

  return (
    <>
      <Modal open={showDeleteModal} onClose={() => setShowDeleteModal(false)}>
        <ConfirmModal
          title="Delete source"
          message="Are you sure you want to delete this source? This action cannot be undone."
          onConfirm={onConfirmDelete}
          confirmButtonText="Delete"
          onCancel={() => setShowDeleteModal(false)}
        />
      </Modal>

      <DetailCardSection title="Edit source">
        <p className="mb-3 text-sm text-stone-600">
          Update the source&apos;s connection settings, schemas, or credentials.
        </p>
        <Button
          text="Edit source"
          type={ButtonStyle.TERTIARY}
          onClick={() => navigate(`/import/sources/${source.id}/edit`)}
        />
      </DetailCardSection>

      <DangerZone actions={dangerZoneActions} type="card" />
    </>
  );
};

export default SourceAdmin;
